import { useEffect, useState } from 'react';
import { templatesApi } from '../../shared/api/templates.api';
import type { Template, TemplateType } from '../../entities/template';

type LoadState = { reel: Template | null; post: Template | null; isLoading: boolean };

function normalizeType(t: any): TemplateType {
  // Legacy без type = историчный единый шаблон = reel.
  return t?.type === 'post' ? 'post' : 'reel';
}

/**
 * Грузит оба шаблона аккаунта (reel + post). Без авто-миграции:
 * существующий (legacy) шаблон попадает в reel; post создаётся вручную.
 */
export function useAccountTemplates(accountId: string | undefined): LoadState {
  const [state, setState] = useState<LoadState>({ reel: null, post: null, isLoading: !!accountId });

  useEffect(() => {
    if (!accountId) {
      setState({ reel: null, post: null, isLoading: false });
      return;
    }
    let cancelled = false;
    setState((s) => ({ ...s, isLoading: true }));

    (async () => {
      const all = await templatesApi.getAllByAccountId(accountId);
      // При дублях одного типа берём самый свежий по updatedAt.
      const latest = (type: TemplateType): Template | null => {
        const matches = all
          .filter((t) => normalizeType(t) === type)
          .sort((a, b) => String((b as any).updatedAt || '').localeCompare(String((a as any).updatedAt || '')));
        return (matches[0] as unknown as Template) || null;
      };
      const reel = latest('reel');
      const post = latest('post');
      if (!cancelled) setState({ reel, post, isLoading: false });
    })().catch(() => {
      if (!cancelled) setState({ reel: null, post: null, isLoading: false });
    });

    return () => { cancelled = true; };
  }, [accountId]);

  return state;
}
